import "./App.css";
import "./style/markdown.css";
//highlight.js
import 'highlight.js/styles/github-dark.css';
//md-editor
import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';
import { Stack } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TodoProvider } from "./components/Todo/context/TodoContext/TodoContext";
import LoadingContextProvider from "./context/Loading/LoadingContextProvider";
import { CustomThemeProvider } from "./context/Theme/ThemeContext";
import AppRouter from "./router/AppRouter";
import { SnackbarContent, SnackbarProvider, SnackbarProviderProps } from "notistack";
import { setSnackbarRef } from "./util/snackbarUtil";
import { useTheme } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getEnvStr } from "./util/envFn";
import { LoginProvider } from "./context/Login/LoginContext";

function App() {
    return (
        <GoogleOAuthProvider clientId={getEnvStr("{GOOGLE_CLIENT_ID}")}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomThemeProvider>
                    <LoadingContextProvider>
                        <NotistackSnackbarProvider>
                            <LoginProvider>
                                <TodoProvider>
                                    <Stack
                                        direction="row"
                                        sx={{
                                            minHeight: "100dvh",
                                            minWidth: "100%",
                                            bgcolor: "background.default",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <AppRouter />
                                    </Stack>
                                </TodoProvider>
                            </LoginProvider>
                        </NotistackSnackbarProvider>
                    </LoadingContextProvider>
                </CustomThemeProvider>
            </LocalizationProvider>
        </GoogleOAuthProvider>
    );
}

const NotistackSnackbarProvider = (props: SnackbarProviderProps) => {
    const theme = useTheme();

    return (
        <SnackbarProvider ref={setSnackbarRef}
            maxSnack={3}
            autoHideDuration={3000}
            preventDuplicate
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            style={{
                fontSize: theme.typography?.caption?.fontSize,
                fontFamily: theme.typography?.caption?.fontFamily,
            }}
            Components={{
                default: (props) => (
                    <SnackbarContent
                        {...props}
                        style={{
                            fontSize: theme.typography?.caption?.fontSize,
                            fontFamily: theme.typography?.caption?.fontFamily,
                        }}
                    />
                )
            }}
            {...props}
        />
    );
};

export default App;
